import { Navigate, useLocation } from "react-router-dom";
import useDigitalSubscriptionUX from "components/hooks/useDigitalSubscriptionUX";
import MemberSecrets from "./MemberSecrets";

// /access is the combined Secrets + Integrations experience for digital subscription users.
// Non-digital members keep the plain Secrets page at /secrets, so guard against direct hits.
export const AccessPage = () => {
  const isDigital = useDigitalSubscriptionUX();
  const { search } = useLocation();
  if (!isDigital) {
    return <Navigate to={`/secrets${search}`} replace />;
  }
  return <MemberSecrets showIntegrations />;
};

// /secrets aliases to /access for digital users (keeps existing links/refs working); everyone
// else gets the unchanged Secrets page.
export const SecretsRoute = () => {
  const isDigital = useDigitalSubscriptionUX();
  const { search } = useLocation();
  if (isDigital) {
    return <Navigate to={`/access${search}`} replace />;
  }
  return <MemberSecrets />;
};
